<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <!--a class="pull-left img-back" href="javascript:window.history.go(-1)" v-tap>返回</a-->
        <h1>联系人</h1>
        <span class="pull-right icon-right icon-setup text-hide hide" @click="sheetVisible = true">添加</span>
      </div>
      <div class="liner"></div>
    </div>

    <div class="main-page">
      <div class="contact">
        <ul class="list-group-item">
          <li class="img-teacher">
            <div class="liner"></div>
              <router-link class="padding-15 margin-x-15 block img-more clearfix" :to="{'path': '/teacher/manage'}">
                <span class="pull-left margin-x-15">老师</span>
                <span class="pull-right gray">{{teacherList.length}}</span>
              </router-link>
          </li>
          <li class="img-parents">
            <div class="liner"></div>
            <router-link class="padding-15 margin-x-15 block img-more clearfix" :to="{'path': '/contact/parent'}">
                <span class="pull-left margin-x-15">家长</span>
                <span class="pull-right gray">{{parentsNum}}</span>
            </router-link>
          </li>
           <li class="img-kids">
            <div class="liner"></div>
            <router-link class="padding-15 margin-x-15 block img-more clearfix" :to="{'path': '/student/manage'}">
                <span class="pull-left margin-x-15">学生</span>
                <span class="pull-right gray">{{studentLength}}</span>
            </router-link>
          </li>
        </ul>

        <div>
          <p class="margin-15 font-12">我的群</p>
          <ul class="list-group-item">
            <li v-for="item in teacherClassList">
              <div class="liner"></div>
              <router-link tag="div" class="padding-15 clearfix" :to="{'path':'/class/edit/' + item.classId}">
                <div class="clearfix">
                  <cite class="pull-left">{{item.className}}</cite>
                  <cite class="gray pull-right">{{item.studentNum}}</cite>
                </div>
              </router-link>
            </li>
          </ul>
          <ul class="list-group-item" v-if="teacherClassList.length == 0">
            <li>
              <div class="liner"></div>
              <div class="padding-15 clearfix font-12 gray">您还没有加入任何群</div>
            </li>
          </ul>
        </div>


        <!-- <div>
          <p class="margin-15 font-12">常用联系人</p>
          <ul class="list-group-item primary">
            <li class="list-group">
              <div class="list-group">
                <div class="liner"></div>
                <router-link class="group-link clearfix" :to="{'path': '/student/manage'}">
                  <span class="img-wrap small pull-left">
                    <img src="../../assets/images/wyz.jpg" width="100%"/>
                  </span>
                  <span class="group-txt">
                    <span class="block overhide">
                      <cite class="pull-left">陈继琴哥哥</cite>
                    </span>
                  </span>
                </router-link>
              </div>
            </li>
          </ul>
        </div> -->

      </div>
    </div>

    <div class="navbar" style="z-index:1000;">
      <div class="liner"></div>
      <ul class="clearfix text-center">
        <li><router-link class="img-home" :to="{path:'/index'}"><span>管理</span></router-link></li>
        <template v-if="isVisitor">
        <li><router-link class="img-xiaoxi" :to="{path:'/user/center/NewsClass'}"><span>消息</span></router-link></li>
        <li><router-link class="icon-add icon" :to="{path:'/quickadd'}">添加</router-link></li>
        <li><a class="img-contact active" @click.prevent="showCurche"><span>联系人</span></a></li>
        <li><router-link class="img-user" :to="{path:'/user/center'}"><span>我的</span></router-link></li>
        </template>
        <template v-else>
        <li><router-link class="img-xiaoxi" :to="{path:'/user/center/NewsClass'}"><span>消息</span></router-link></li>
        <li><router-link class="icon-add icon"  :to="{path:'/quickadd'}">添加</router-link></li>
        <li><a class="img-contact active" href="javascript:;"><span>联系人</span></a></li>
        <li><router-link class="img-user" :to="{path:'/user/center'}"><span>我的</span></router-link></li>
        </template>
      </ul>
    </div>

    <mt-actionsheet
      :actions="[{'name': '添加老师', 'method': addTeacher}, {'name': '添加学生 / 家长', 'method': addParent}]"
      v-model="sheetVisible">
    </mt-actionsheet>
  </div>
</template>

<script>
import { service } from '../../service'
import { mapGetters, mapMutations } from 'vuex'

export default {
  computed: mapGetters({
    classList: 'classList',
    studentLength: 'studentLength',
    parentsNum: 'parentsNum',
    teacherList: 'teacherList',
    teacherClassList: 'teacherClassList'
  }),
  data () {
    return {
      login_data: JSON.parse(window.localStorage['login_data']),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      find_new_class_list_para: service.setPara('findNewClassList'),
      get_new_student_list_para: service.setPara('getNewStudentList'),
      get_student_list_para: service.setPara('getStudentList'),
      get_curche_teacher_para: service.setPara('getCurcheTeacher'),
      sheetVisible: false,
      isVisitor: false
    }
  },
  mounted: function () {
    if (this.login_data.length == 0) {
      this.isVisitor = true
    } else {
      this.find_new_class_list_para.curcheId = this.cookie_login_data.curcheId
      this.find_new_class_list_para.context = this
      this.find_new_class_list_para.callback = () => {
        this.$store.dispatch('teacherClass', this.cookie_login_data.teacherId)
      }
      this.$store.dispatch('receiveClass', this.find_new_class_list_para)

      this.get_new_student_list_para.curcheId = this.cookie_login_data.curcheId
      this.get_new_student_list_para.sfzt = '在托'
      this.get_new_student_list_para.context = this
      this.$store.dispatch('receiveStudents', this.get_new_student_list_para)

      this.get_student_list_para.curcheId = this.cookie_login_data.curcheId
      this.get_student_list_para.context = this
      this.$store.dispatch('receiveStudentsAndParents', this.get_student_list_para)

      this.get_curche_teacher_para.curcheId = this.cookie_login_data.curcheId
      this.get_curche_teacher_para.context = this
      this.$store.dispatch('receiveTeachers', this.get_curche_teacher_para)
    }
  },
  methods: {
    ...mapMutations([
      'receiveStudents',
      'receiveClass',
      'receiveStudentsAndParents',
      'receiveTeachers',
      'teacherClass'
    ]),
    addTeacher: function () {
      this.$router.push('/invitation/teacher')
    },
    addParent: function () {
      this.$router.push('/invitation/parents')
    }
  }
}
</script>
<style scoped>
  .main-page{padding-bottom:60px;}
</style>



// WEBPACK FOOTER //
// contact.vue?77de7861